// Arabic quiz questions dataset with mixed content types
// Each question has: question, answers, correctAnswer, type, and optional image fields

export const questions = [
  {
    id: 1,
    type: 'text-text', // Text question + text answers
    question: 'ما هي عاصمة المملكة العربية السعودية؟',
    answers: ['الرياض', 'جدة', 'مكة المكرمة', 'الدمام'],
    correctAnswer: 0
  },


  {
    id: 5,
    type: 'text-text',
    question: 'في أي عام تأسست المملكة العربية السعودية؟',
    answers: ['1932', '1920', '1925', '1940'],
    correctAnswer: 0
  },

  {
    id: 7,
    type: 'text-text',
    question: 'ما هو الحيوان الذي يُعتبر رمزاً للصحراء؟',
    answers: ['الجمل', 'الحصان', 'الغزال', 'الذئب'],
    correctAnswer: 0
  },



  {
    id: 11,
    type: 'text-text',
    question: 'في أي سنة هجرية صدر المرسوم الملكي بتوحيد المملكة العربية السعودية تحت هذا الاسم؟',
    answers: ['1350 هـ', '1351 هـ', '1352 هـ', '1353 هـ'],
    correctAnswer: 1
  },
  {
    id: 12,
    type: 'text-text',
    question: 'ما هو اللون الذي يرمز إلى السلام والقوة في العلم السعودي؟',
    answers: ['الأبيض', 'الأخضر', 'الأسود', 'الأزرق'],
    correctAnswer: 1
  },
  {
    id: 13,
    type: 'text-text',
    question: 'كم كان عمر الملك عبدالعزيز عند استعادة الرياض عام 1319هـ؟',
    answers: ['20 سنة', '23 سنة', '26 سنة', '30 سنة'],
    correctAnswer: 1
  },
  {
    id: 14,
    type: 'text-text',
    question: 'ما هو أكبر احتفال لليوم الوطني من حيث عدد الفعاليات كان في أي عام؟',
    answers: ['2018', '2019', '2021', '2022'],
    correctAnswer: 3
  },
  {
    id: 15,
    type: 'text-text',
    question: 'ما هو شعار اليوم الوطني السعودي الـ 93 (عام 2023)؟',
    answers: ['هي لنا دار', 'نحلم ونحقق', 'دام عزك يا وطن', 'قوة وعزيمة'],
    correctAnswer: 1
  },
  {
    id: 16,
    type: 'text-text',
    question: 'في أي يوم ميلادي يوافق اليوم الوطني السعودي؟',
    answers: ['21 سبتمبر', '22 سبتمبر', '23 سبتمبر', '24 سبتمبر'],
    correctAnswer: 2
  },
  {
    id: 17,
    type: 'text-text',
    question: 'من هو الملك الذي أُعلن في عهده "اليوم الوطني" عطلة رسمية في المملكة لأول مرة؟',
    answers: ['الملك عبدالعزيز', 'الملك خالد', 'الملك فهد', 'الملك عبدالله'],
    correctAnswer: 2
  },
  {
    id: 18,
    type: 'text-text',
    question: 'ما اسم المعركة التي كانت نقطة تحول كبرى في توحيد المملكة بعد استعادة الرياض؟',
    answers: ['معركة بدر', 'معركة روضة مهنا', 'معركة السبيعة', 'معركة جراب'],
    correctAnswer: 1
  },
  {
    id: 19,
    type: 'text-text',
    question: 'كم عدد المناطق الإدارية في المملكة العربية السعودية اليوم؟',
    answers: ['11', '13', '14', '16'],
    correctAnswer: 1
  },
  {
    id: 20,
    type: 'text-text',
    question: 'أول نشيد وطني سعودي تمت كتابته وأداؤه في أي عهد ملكي؟',
    answers: ['عهد الملك عبدالعزيز', 'عهد الملك سعود', 'عهد الملك فيصل', 'عهد الملك خالد'],
    correctAnswer: 3
  },
  {
    id: 21,
    type: 'text-text',
    question: 'ما هو أطول وادٍ في المملكة العربية السعودية؟',
    answers: ['وادي حنيفة', 'وادي الدواسر', 'وادي الرمة', 'وادي فاطمة'],
    correctAnswer: 2
  },
  {
    id: 22,
    type: 'text-text',
    question: 'ما هي المدينة التي تُعرف بأنها "عاصمة الثقافة الإسلامية" في المملكة؟',
    answers: ['الرياض', 'مكة المكرمة', 'المدينة المنورة', 'جدة'],
    correctAnswer: 2
  },
  
  // Saudi National Day Logo Questions - Image to Text
  {
    id: 23,
    type: 'image-text',
    questionImage: '/QnA/عزنا-بأصالتنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بأصالتنا', 'عِزّنا بكرمنا', 'عِزّنا بطموحنا', 'عِزّنا برؤيتنا'],
    correctAnswer: 0
  },
  {
    id: 24,
    type: 'image-text',
    questionImage: '/QnA/عزنا-بكرمنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بجودنا', 'عِزّنا بكرمنا', 'عِزّنا بفزعتنا', 'عِزّنا بأصالتنا'],
    correctAnswer: 1
  },
  {
    id: 25,
    type: 'image-text',
    questionImage: '/QnA/عزنا-بفزعتنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بطموحنا', 'عِزّنا برؤيتنا', 'عِزّنا بفزعتنا', 'عِزّنا بكرمنا'],
    correctAnswer: 2
  },
  {
    id: 26,
    type: 'image-text',
    questionImage: '/QnA/عزنا-بطموحنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بأصالتنا', 'عِزّنا بطموحنا', 'عِزّنا بجودنا', 'عِزّنا بفزعتنا'],
    correctAnswer: 1
  },
  {
    id: 27,
    type: 'image-text',
    questionImage: '/QnA/عزنا-برؤيتنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بكرمنا', 'عِزّنا بفزعتنا', 'عِزّنا برؤيتنا', 'عِزّنا بطموحنا'],
    correctAnswer: 2
  },
  {
    id: 28,
    type: 'image-text',
    questionImage: '/QnA/عزنا-بجودنا.png',
    question: 'ما هي العبارة التي ترمز إلى هذا الشعار؟',
    answers: ['عِزّنا بجودنا', 'عِزّنا برؤيتنا', 'عِزّنا بأصالتنا', 'عِزّنا بطموحنا'],
    correctAnswer: 0
  },
  
  // Saudi National Day Logo Questions - Text to Image  
  {
    id: 29,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا بأصالتنا"',
    answers: [
      { text: 'عِزّنا بأصالتنا', image: '/QnA/عزنا-بأصالتنا.png' },
      { text: 'عِزّنا بكرمنا', image: '/QnA/عزنا-بكرمنا.png' },
      { text: 'عِزّنا بفزعتنا', image: '/QnA/عزنا-بفزعتنا.png' },
      { text: 'عِزّنا بطموحنا', image: '/QnA/عزنا-بطموحنا.png' }
    ],
    correctAnswer: 0
  },
  {
    id: 30,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا بكرمنا"',
    answers: [
      { text: 'عِزّنا بجودنا', image: '/QnA/عزنا-بجودنا.png' },
      { text: 'عِزّنا بكرمنا', image: '/QnA/عزنا-بكرمنا.png' },
      { text: 'عِزّنا برؤيتنا', image: '/QnA/عزنا-برؤيتنا.png' },
      { text: 'عِزّنا بفزعتنا', image: '/QnA/عزنا-بفزعتنا.png' }
    ],
    correctAnswer: 1
  },
  {
    id: 31,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا بفزعتنا"',
    answers: [
      { text: 'عِزّنا بطموحنا', image: '/QnA/عزنا-بطموحنا.png' },
      { text: 'عِزّنا بأصالتنا', image: '/QnA/عزنا-بأصالتنا.png' },
      { text: 'عِزّنا بفزعتنا', image: '/QnA/عزنا-بفزعتنا.png' },
      { text: 'عِزّنا برؤيتنا', image: '/QnA/عزنا-برؤيتنا.png' }
    ],
    correctAnswer: 2
  },
  {
    id: 32,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا بطموحنا"',
    answers: [
      { text: 'عِزّنا بكرمنا', image: '/QnA/عزنا-بكرمنا.png' },
      { text: 'عِزّنا بطموحنا', image: '/QnA/عزنا-بطموحنا.png' },
      { text: 'عِزّنا بجودنا', image: '/QnA/عزنا-بجودنا.png' },
      { text: 'عِزّنا بأصالتنا', image: '/QnA/عزنا-بأصالتنا.png' }
    ],
    correctAnswer: 1
  },
  {
    id: 33,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا برؤيتنا"',
    answers: [
      { text: 'عِزّنا بفزعتنا', image: '/QnA/عزنا-بفزعتنا.png' },
      { text: 'عِزّنا برؤيتنا', image: '/QnA/عزنا-برؤيتنا.png' },
      { text: 'عِزّنا بكرمنا', image: '/QnA/عزنا-بكرمنا.png' },
      { text: 'عِزّنا بطموحنا', image: '/QnA/عزنا-بطموحنا.png' }
    ],
    correctAnswer: 1
  },
  {
    id: 34,
    type: 'text-image',
    question: 'لأي شعار ترمز هذه العبارة؟ "عِزّنا بجودنا"',
    answers: [
      { text: 'عِزّنا بجودنا', image: '/QnA/عزنا-بجودنا.png' },
      { text: 'عِزّنا بأصالتنا', image: '/QnA/عزنا-بأصالتنا.png' },
      { text: 'عِزّنا برؤيتنا', image: '/QnA/عزنا-برؤيتنا.png' },
      { text: 'عِزّنا بفزعتنا', image: '/QnA/عزنا-بفزعتنا.png' }
    ],
    correctAnswer: 0
  }
];

// Utility function to get 5 random questions with randomized answer positions
export const getRandomQuestions = (questionsArray = questions, count = 5) => {
  // Separate questions by type
  const textTextQuestions = questionsArray.filter(q => q.type === 'text-text');
  const imageTextQuestions = questionsArray.filter(q => q.type === 'image-text');
  const textImageQuestions = questionsArray.filter(q => q.type === 'text-image');
  
  // Always include at least one of each type
  const selectedQuestions = [];
  
  // Add one random question from each type
  if (textTextQuestions.length > 0) {
    const randomTextText = textTextQuestions[Math.floor(Math.random() * textTextQuestions.length)];
    selectedQuestions.push(randomTextText);
  }
  
  if (imageTextQuestions.length > 0) {
    const randomImageText = imageTextQuestions[Math.floor(Math.random() * imageTextQuestions.length)];
    selectedQuestions.push(randomImageText);
  }
  
  if (textImageQuestions.length > 0) {
    const randomTextImage = textImageQuestions[Math.floor(Math.random() * textImageQuestions.length)];
    selectedQuestions.push(randomTextImage);
  }
  
  // Fill remaining slots with random questions from any type
  const remainingSlots = count - selectedQuestions.length;
  if (remainingSlots > 0) {
    const allQuestions = [...questionsArray];
    const availableQuestions = allQuestions.filter(q => !selectedQuestions.includes(q));
    const shuffled = [...availableQuestions].sort(() => 0.5 - Math.random());
    const additionalQuestions = shuffled.slice(0, remainingSlots);
    selectedQuestions.push(...additionalQuestions);
  }
  
  // Shuffle the final selection to randomize order
  const finalShuffled = [...selectedQuestions].sort(() => 0.5 - Math.random());
  
  // Then randomize answer positions for each question
  return finalShuffled.map(question => {
    // For image answers, we need to handle objects differently
    if (question.type === 'text-image') {
      const answersWithIndex = question.answers.map((answer, index) => ({
        ...answer,
        originalIndex: index
      }));
      
      // Shuffle the answers
      const shuffledAnswers = [...answersWithIndex].sort(() => 0.5 - Math.random());
      
      // Find new position of correct answer
      const newCorrectAnswer = shuffledAnswers.findIndex(
        answer => answer.originalIndex === question.correctAnswer
      );
      
      // Remove originalIndex before returning
      const cleanAnswers = shuffledAnswers.map(({ originalIndex, ...answer }) => answer);
      
      return {
        ...question,
        answers: cleanAnswers,
        correctAnswer: newCorrectAnswer
      };
    } else {
      // For text answers, create array with original indices
      const answersWithIndex = question.answers.map((answer, index) => ({
        text: answer,
        originalIndex: index
      }));
      
      // Shuffle the answers
      const shuffledAnswers = [...answersWithIndex].sort(() => 0.5 - Math.random());
      
      // Find new position of correct answer
      const newCorrectAnswer = shuffledAnswers.findIndex(
        answer => answer.originalIndex === question.correctAnswer
      );
      
      // Extract just the text
      const cleanAnswers = shuffledAnswers.map(answer => answer.text);
      
      return {
        ...question,
        answers: cleanAnswers,
        correctAnswer: newCorrectAnswer
      };
    }
  });
};
